import { useParams, Navigate } from "react-router-dom";
import { Reveal } from "../components/Reveal";

const CONTENT = {
  cgv: {
    title: "Conditions Générales de Vente",
    sections: [
      ["Article 1 — Objet", "Les présentes conditions générales de vente régissent les relations contractuelles entre LUXE ORYVEA PREMIUM et toute personne effectuant un achat sur le site. Toute commande implique l'acceptation sans réserve des présentes conditions."],
      ["Article 2 — Produits", "Les produits proposés sont des soins cosmétiques. Les photographies et descriptifs sont fournis à titre indicatif et sont les plus fidèles possibles, sans engager la responsabilité du vendeur en cas de légère différence."],
      ["Article 3 — Prix", "Les prix sont indiqués en euros toutes taxes comprises (TTC). LUXE ORYVEA PREMIUM se réserve le droit de modifier ses prix à tout moment ; les produits sont facturés sur la base des tarifs en vigueur au moment de la commande."],
      ["Article 4 — Commande", "La commande est validée après confirmation du paiement. Un email de confirmation récapitulant la commande est envoyé à l'adresse indiquée par le client."],
      ["Article 5 — Paiement", "Le paiement s'effectue en ligne via un prestataire de paiement sécurisé. Les données bancaires ne transitent jamais par nos serveurs."],
      ["Article 6 — Droit applicable", "Les présentes conditions sont soumises au droit français. En cas de litige, une solution amiable sera recherchée en priorité."],
    ],
  },
  livraison: {
    title: "Livraison",
    sections: [
      ["Zones desservies", "Nous livrons en France métropolitaine ainsi que dans plusieurs pays européens (Belgique, Suisse, Luxembourg, Monaco)."],
      ["Frais de livraison", "La livraison est offerte dès 60 € d'achat. En dessous de 60 €, la livraison à domicile est facturée 5,90 € et la livraison en Point Relais / Locker 4,90 €."],
      ["Délais", "Les commandes sont préparées avec soin et expédiées sous 24 à 48 heures ouvrées. Le délai d'acheminement dépend ensuite du transporteur et de la destination."],
      ["Suivi", "Dès l'expédition de votre commande, les informations de suivi vous sont communiquées par email."],
    ],
  },
  retours: {
    title: "Retours & Remboursements",
    sections: [
      ["Droit de rétractation", "Conformément à la réglementation, vous disposez d'un délai de 14 jours à compter de la réception de votre commande pour exercer votre droit de rétractation, sans avoir à justifier de motif."],
      ["Conditions de retour", "Pour des raisons d'hygiène, seuls les produits non ouverts et dans leur emballage d'origine peuvent faire l'objet d'un retour."],
      ["Procédure", "Contactez notre service client via le formulaire de contact afin d'obtenir les modalités de retour de votre produit."],
      ["Remboursement", "Le remboursement est effectué après réception et vérification du produit retourné, dans les meilleurs délais et via le moyen de paiement initial."],
    ],
  },
  confidentialite: {
    title: "Politique de Confidentialité",
    sections: [
      ["Données collectées", "Nous collectons uniquement les données nécessaires au traitement de vos commandes et à la relation client : nom, adresse email, adresse de livraison."],
      ["Utilisation", "Vos données sont utilisées pour traiter vos commandes, assurer le suivi de livraison et répondre à vos demandes. Elles ne sont ni vendues ni cédées à des tiers à des fins commerciales."],
      ["Paiement", "Les informations de paiement sont traitées directement par notre prestataire de paiement sécurisé et ne sont pas conservées sur nos serveurs."],
      ["Vos droits", "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Contactez-nous via le formulaire de contact pour exercer ces droits."],
    ],
  },
};

export default function Legal() {
  const { slug } = useParams();
  const data = CONTENT[slug];
  if (!data) return <Navigate to="/" replace />;
  return (
    <div className="pt-32 pb-32 min-h-[70vh]">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="overline mb-4">Informations</p>
          <h1 className="font-display text-5xl md:text-6xl mb-16" style={{ fontWeight: 300 }}>{data.title}</h1>
        </Reveal>
        <div className="space-y-12">
          {data.sections.map(([title, body], i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-2xl mb-3" style={{ fontWeight: 400, color: "var(--lo-rose-hi)" }}>{title}</h2>
                <p className="text-sm leading-relaxed" style={{ color: "var(--lo-muted)" }}>{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
